import { render, staticRenderFns } from "./viewPages.vue?vue&type=template&id=9690671c&scoped=true&"
import script from "./viewPages.vue?vue&type=script&lang=ts&"
export * from "./viewPages.vue?vue&type=script&lang=ts&"
import style0 from "./viewPages.vue?vue&type=style&index=0&id=9690671c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690671c",
  null
  
)

export default component.exports